<template>
  <div v-if="currentItem" class="scmcc-header-carousel">
    <div
      ref="Scroller"
      class="scmcc-header-carousel--content"
      :style="contentStyle"
    >
      <a
        ref="Content"
        @mouseenter="stop"
        @mouseleave="start"
        @click="handleClick"
        >{{ currentItem.digest }}</a
      >
    </div>
    <modal
      class-name="com-scmcc-header-carousel-modal"
      v-model="modal.visible"
      footer-hide
      title="跑马灯"
    >
      <p class="content">{{ modal.data.digest }}</p>
      <p class="info">
        发布人：{{ modal.data.sender }}
        <span class="split">/</span> 发布时间：{{ modal.data.sendTime }}
      </p>
    </modal>
  </div>
</template>
<script>
import {dateFormat} from '../../assets/utils.js'
import envConst from '@/env-const.js'
export default {
  data() {
    return {
      x: 0, // 平移x坐标
      messages: [], // 消息列表
      currentItem: null, // 当前项
      modal: { data: {}, visible: false } // 对话框选项 --> 数据和可见性
    }
  },
  computed: {
    contentStyle() {
      return { transform: `translateX(${this.x}px)` }
    }
  },
  mounted() {
    this.poll()
  },
  beforeDestroy() {
    this.stop()
    this.stopPoll()
  },
  methods: {
    init() {
      if (this.currentItem) return
      this.updateCurrentItem()
      setTimeout(this.start, 3000)
    },
    // 更新平移x坐标
    updateTranslateX() {
      if (!this.currentItem) {
        this.x = 0
        return this.stop()
      }
      const [scrollEl, contentEl] = [this.$refs.Scroller, this.$refs.Content]
      if (!scrollEl) return
      if (this.x < -contentEl.offsetWidth) {
        this.updateCurrentItem()
        this.x = scrollEl.offsetWidth
      } else {
        this.x--
      }
    },
    // 开始
    start() {
      this.stop()
      this.tid = setInterval(this.updateTranslateX, 30)
    },
    // 停止
    stop() {
      clearInterval(this.tid)
    },
    // 更新当前项
    updateCurrentItem() {
      // 当前项不存在 那么设置数组第一个元素为当前项
      if (!this.currentItem) return (this.currentItem = this.messages[0])
      let len = this.messages.length
      // 查找当前索引
      let currentIndex = this.messages.findIndex(
        _ => _.shnId === this.currentItem.shnId
      )
      // 如果没找到或者是数组最后一项，那么数组第一个元素设为当前项，否则数组下一项为当前项
      this.currentItem = this.messages[
        [-1, len - 1].indexOf(currentIndex) === -1 ? currentIndex + 1 : 0
      ]
    },
    // 单击处理
    handleClick() {
      let sendTime = dateFormat(this.currentItem.sendTime, 'yyyy.MM.dd')
      this.modal = { visible: true, data: { ...this.currentItem, sendTime } }
    },
    // 获取数据
    getData() {
      let { userId } = this.$store.state.main.user.info
      return this.$http(
        `${
          envConst.API_BASE_URL
        }/scbf/notice/marqueeList?receiver=${userId}&moduleCode=scbf2`
      ).then(({ data }) => {
        let now = new Date()
        let { returnCode, returnMessage, beans } = data
        return returnCode === 0
          ? beans.filter(_ => new Date(_.sendTime) < now)
          : Promise.reject(new Error(returnMessage))
      })
    },
    // 停止轮询
    stopPoll() {
      clearTimeout(this.pollTid)
    },
    // 轮询
    poll() {
      this.stopPoll()
      this.getData()
        .then(data => {
          this.messages = data
        })
        .then(() => {
          this.init()
          this.pollTid = setTimeout(this.poll, 60000)
        })
    }
  }
}
</script>
<style lang="stylus">
.scmcc-header-carousel
  width 0
  flex 1
  position relative
  margin-right 70px
  padding-left 34px
  overflow hidden
  white-space nowrap

  &:before
    content ''
    position absolute
    top 0
    bottom 0
    left 0
    z-index 1
    width 34px
    background #fff url('~@/assets/images/audio.svg') no-repeat 0 50%

  &--content
    font-size 14px

    a:not(:hover)
      color #515A6E

  &:after
    content ''
    position absolute
    top 0
    right 0
    bottom 0
    width 42px
    background-image linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.88) 64%, rgba(255, 255, 255, 0) 86%)

.com-scmcc-header-carousel-modal
  display flex
  align-items center
  justify-content center

  .ivu-modal
    top 0
    max-width 384px

  .ivu-modal-header
    text-align center
    padding-top 30px
    padding-bottom 30px
    border-bottom none

  .ivu-modal-header-inner
    font-size 16px

  .ivu-modal-body
    padding 0 30px 52px

    .content
      font-size 14px
      color #515A6E
      margin-bottom 18px

    .info
      font-size 12px
      color #90959E

    .split
      margin 0 7px
</style>